// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ConferenciaController from "./conferencia_controller"
application.register("conferencia", ConferenciaController)

import ComentariosController from "./comentarios_controller"
application.register("comentarios", ComentariosController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import HistoryBackController from "./history_back_controller"
application.register("history-back", HistoryBackController)

import MaskController from "./mask_controller"
application.register("mask", MaskController)

import Portais__IndiceController from "./portais/indice_controller"
application.register("portais--indice", Portais__IndiceController)

import Portais__PageNavController from "./portais/page_nav_controller"
application.register("portais--page-nav", Portais__PageNavController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchPanelController from "./search_panel_controller"
application.register("search-panel", SearchPanelController)

import SourcesController from "./sources_controller"
application.register("sources", SourcesController)

import TogglerController from "./toggler_controller"
application.register("toggler", TogglerController)

import Ui__CascadeController from "./ui/cascade_controller"
application.register("ui--cascade", Ui__CascadeController)

import Ui__ComboboxController from "./ui/combobox_controller"
application.register("ui--combobox", Ui__ComboboxController)

import Ui__DisclosureController from "./ui/disclosure_controller"
application.register("ui--disclosure", Ui__DisclosureController)

import Ui__DismissController from "./ui/dismiss_controller"
application.register("ui--dismiss", Ui__DismissController)

import Ui__DropdownController from "./ui/dropdown_controller"
application.register("ui--dropdown", Ui__DropdownController)

import Ui__ModalController from "./ui/modal_controller"
application.register("ui--modal", Ui__ModalController)

import Ui__RemoteToggleController from "./ui/remote_toggle_controller"
application.register("ui--remote-toggle", Ui__RemoteToggleController)

import Ui__TabsController from "./ui/tabs_controller"
application.register("ui--tabs", Ui__TabsController)

import Ui__TabsListController from "./ui/tabs_list_controller"
application.register("ui--tabs-list", Ui__TabsListController)

import Ui__TabsNavController from "./ui/tabs_nav_controller"
application.register("ui--tabs-nav", Ui__TabsNavController)

import Ui__TooltipController from "./ui/tooltip_controller"
application.register("ui--tooltip", Ui__TooltipController)

import Ui__TurboModalController from "./ui/turbo_modal_controller"
application.register("ui--turbo-modal", Ui__TurboModalController)
